import { Avatar, Box, Typography, Paper, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

import Markdown from "components/common/Markdown";

export default function CommentItem({ id, author, date, comment, created_at, onDelete }) {
  const deleteComment = () => {
    onDelete(id);
  };

  return (
    <Paper variant="outlined" sx={{ p: 2, borderRadius: 2, position: "relative" }}>
      <IconButton size="small" onClick={deleteComment} sx={{ position: "absolute", top: 8, right: 8 }}>
        <DeleteIcon fontSize="small" />
      </IconButton>
      <Box display="flex" gap={2} className="teacher-comment">
        <Avatar src={author.photo} alt={`${author.first_name} ${author.last_name}`} />

        <Box flexGrow={1}>
          <Box display="flex" alignItems="center" gap={1}>
            <Typography variant="subtitle1" fontWeight={600}>
              {author.first_name} {author.last_name}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              • {created_at}
            </Typography>
          </Box>

          <Box mt={1}>
            <Typography
              variant="body1"
              sx={{
                "& p": { margin: "0 0 8px 0" },
                "& ul, & ol": { paddingLeft: 3 },
              }}
            >
              <Markdown>{comment}</Markdown>
            </Typography>
          </Box>
        </Box>
      </Box>
    </Paper>
  );
}
